import React from "react";
import {useStores} from "../../stores";
import type {CurrencyAbbreviation} from "./CurrencyClasses";
import {_toCurrencyWithP} from "./CurrencyClasses";

type Props = {
    v: number | null
    vP?: number
    nDigits?: number
    abbreviation?: CurrencyAbbreviation
    hideAlmostZero?: boolean
    noTitle?: boolean
};
export const CurrencyComponent: React.FC<Props> = ({v, vP, nDigits = 3, abbreviation, hideAlmostZero, noTitle}) => {
    const {p} = useStores();
    const [str, vanillaStr] = _toCurrencyWithP(v ?? 0, p.currencyFormat, p.currencySymbol, vP, nDigits, abbreviation, hideAlmostZero);
    return <span title={noTitle ? undefined : vanillaStr}>{str}</span>
};
